<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content">
                    <h2>Terms &amp; Conditions</h2>
                    <terms-conditions-content class="font-lg"></terms-conditions-content>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import TermsConditionsContent from '@/components/content/static/TermsConditions.vue';
    export default {
        name: 'about',
        components: {
            'terms-conditions-content': TermsConditionsContent
        }
    }
</script>



// WEBPACK FOOTER //
// TermsConditions.vue?9f0979aa